module.exports = "https://r.nearpod.com/assets/media/image/calendar-icon-dcf4187006d295464b82e2fed622ae25.svg";